import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { AnalyticsSyncWizardStep } from '@monorepo/shared/componentsV2/fullPageWizard/AnalyticsSyncWizardStep/AnalyticsSyncWizardStep';
import { Page } from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { useDatasetForOrigin } from '@monorepo/shared/hooks/datasets/useDatasetByOrigin';
import React from 'react';
import { useParams } from 'react-router-dom';
import { EditLogHeader, WizardStep } from './EditLogHeader';

export function LogAnalyticsSyncPage() {
  useDisableSubnav();

  const { organizationId, logId } = useParams();
  if (!organizationId || !logId) {
    throw new Error(
      'LogAnalyticsSyncPage was rendered in a context without organization or/and log id',
    );
  }

  const { dataset, isLoading: isDatasetLoading } = useDatasetForOrigin({
    organizationId,
    originId: logId,
  });

  if (isDatasetLoading) {
    return (
      <Page>
        <EditLogHeader wizardStep={WizardStep.ANALYTICS_SYNC} />
        <Loading />
      </Page>
    );
  }

  if (!dataset) {
    throw new Error("Couldn't get information about this log.");
  }

  return (
    <Page>
      <EditLogHeader wizardStep={WizardStep.ANALYTICS_SYNC} />
      <ErrorBoundary>
        <AnalyticsSyncWizardStep
          datasetId={dataset.id}
          datasetOriginLabel="Log"
          organizationId={organizationId}
        />
      </ErrorBoundary>
    </Page>
  );
}
